<div class="container">
  <div class="head">
    <div mat-dialog-title
         class="head-label">Modifier group modal
    </div>
    <mat-icon mat-dialog-close class="head-exit">close</mat-icon>
  </div>

  <div class="form-container">
    <div>
      <mat-form-field>
        <mat-label>{{ 'MENU.NAME' | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="mgName">
      </mat-form-field>
    </div>

    <div *ngFor="let lang of data.organization.additionalLanguages">
      <mat-form-field>
        <mat-label>{{ 'MENU.NAME' | translate }} {{lang}}</mat-label>
        <input matInput type="text" [(ngModel)]="nameTranslations[lang]">
      </mat-form-field>
    </div>

    <div>
      <mat-form-field>
        <mat-label>{{ 'MENU.DESCRIPTION' | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="description">
      </mat-form-field>
    </div>

    <div *ngFor="let lang of data.organization.additionalLanguages">
      <mat-form-field>
        <mat-label>{{ 'MENU.DESCRIPTION' | translate }} {{lang}}</mat-label>
        <input matInput type="text" [(ngModel)]="descriptionTranslations[lang]">
      </mat-form-field>
    </div>

    <div *ngFor="let modifier of modifierProducts">
      {{GetModifierName(modifier.modifierId)}}
    </div>

    <div>

      <button
        class="button"
        mat-button
        (click)="onSubmit()"
      >{{ 'MENU.SAVE' | translate }}
      </button>

      <button
        (click)="onClickSelectModifiers()"
        class="button"
        mat-button>
        Select modifiers
      </button>

    </div>

  </div>


</div>
